// extracted by mini-css-extract-plugin
module.exports = {"grid":"ShelterListPage_grid__21ajy","gridItem":"ShelterListPage_gridItem__1nvcj"};